<script>
  import { onMount } from 'svelte';
  let theme = $state('light');

  onMount(() => {
    theme = localStorage.getItem('hook_theme') || 'light';
    document.documentElement.dataset.theme = theme;
  });

  function toggle() {
    theme = theme === 'light' ? 'dark' : 'light';
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('hook_theme', theme);
  }
</script>

<button
  onclick={toggle}
  class="px-3 py-2 rounded-full hover:bg-surface-container-high text-on-surface-variant"
  title="Toggle theme"
>
  <span class="material-symbols-outlined text-base">
    {theme === 'light' ? 'dark_mode' : 'light_mode'}
  </span>
</button>
